import { keywordsActions } from '../actions'
import ValidateFormObject from '../utils/ValidateFormObject'
const {
  FETCH_KEYWORD,
  FETCHING_KEYWORD,
  FETCH_KEYWORD_ERROR,
  FETCH_KEYWORDS,
  FETCHING_KEYWORDS,
  FETCH_KEYWORDS_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHANGE_KEYWORD,
  DELETE_KEYWORD,
  ADD_KEYWORD,
  EDIT_KEYWORD,
  FORM_TOUCHED,
  NEW_FORM_KEYWORD,
  KEYWORD_FORM_ERROR,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  RESET_STATE
} = keywordsActions

const initialState = {
  loadingKeyword: false,
  loadingKeywords: false,
  fetchKeywordError: false,
  fetchKeywordsError: false,
  keywords: [],
  order: {
    column: 'nome',
    direction: 1
  },
  keyword: {
    nome: '',
    sinonimos: ''
  },
  keywordsPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  keywordFormErrors: {},
  keywordFormTouched: false,
  modalOpen: false
}

const keywordSchema = {
  add: {
    nome: {
      required: true,
      minValue: 3
    },
    sinonimos: {
      required: false
    }
  },
  edit: {
    nome: {
      required: true,
      minValue: 3
    },
    sinonimos: {
      required: false
    }
  }
}

const KeywordValidate = new ValidateFormObject(keywordSchema)

const keywords = (state = initialState, action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_KEYWORD:
      formSchemaType = action.keyword._id ? 'edit' : 'add'
      return {
        ...state,
        keyword: action.keyword,
        keywordFormErrors: KeywordValidate.validate({
          formObject: action.keyword,
          formSchemaType
        })
      }
    case KEYWORD_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.keyword._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        keywordFormErrors: KeywordValidate.validate({
          formObject: state.keyword,
          invalidFields: formErrors,
          formSchemaType
        })
      }
    case NEW_FORM_KEYWORD:
      return {
        ...state,
        keyword: { ...initialState.keyword },
        keywordFormErrors: KeywordValidate.validate({}),
        keywordFormTouched: false
      }
    case FORM_TOUCHED:
      return {
        ...state,
        keywordFormTouched: true
      }
    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }
    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }
    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }
    case FETCH_KEYWORD:
      formSchemaType = (action.keyword || {})._id ? 'edit' : 'add'
      return {
        ...state,
        keyword: action.keyword,
        loadingKeyword: false,
        fetchkeywordError: false,
        keywordFormTouched: false,
        keywordFormErrors: KeywordValidate.validate({
          formObject: action.keyword,
          formSchemaType
        })
      }
    case FETCHING_KEYWORD:
      return {
        ...state,
        loadingKeyword: true,
        fetchKeywordError: false
      }
    case DELETE_KEYWORD:
      return {
        ...state,
        loadingKeywords: false,
        fetchKeywordError: false,
        keywords: state.keywords.map(keyword => {
          if (keyword._id === action.keyword._id) {
            keyword = action.keyword
          }
          return keyword
        })
      }
    case FETCH_KEYWORD_ERROR:
      return {
        ...state,
        loadingKeyword: false,
        keyword: { ...initialState.keyword },
        fetchKeywordError: action.error
      }
    case CHANGE_PAGE:
      return {
        ...state,
        keywordsPagination: {
          ...state.keywordsPagination,
          page: action.page
        }
      }
    case CHANGE_PER_PAGE:
      return {
        ...state,
        keywordsPagination: {
          ...state.keywordsPagination,
          rowsPerPage: action.perPage
        }
      }
    case FETCH_KEYWORDS:
      return {
        ...state,
        loadingKeywords: false,
        keywords: action.keywords,
        fetchKeywordsError: false,
        order: action.order,
        keywordsPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_KEYWORD:
      return {
        ...state,
        keywords: state.keywords.map(keyword => {
          if (keyword._id === action.keyword._id) {
            return action.keyword
          }
          return keyword
        }),
        loadingKeywords: false,
        fetchKeywordError: false,
        loadingKeyword: false,
        fetchKeywordsError: false
      }
    case FETCHING_KEYWORDS:
      return {
        ...state,
        loadingKeywords: true,
        fetchKeywordsError: false
      }
    case FETCH_KEYWORDS_ERROR:
      return {
        ...state,
        loadingKeywords: false,
        fetchKeywordError: action.error,
        loadingKeyword: false
      }
    case ADD_KEYWORD:
      return {
        ...state,
        loadingKeywords: false,
        fetchKeywordError: false,
        loadingKeyword: false,
        keywords: [...state.keywords, action.keyword]
      }
    case RESET_STATE:
      return initialState
    default:
      return state
  }
}

export default keywords



// WEBPACK FOOTER //
// ./src/reducers/keywords.js